import { Component, Inject, OnInit } from '@angular/core';
import { LANG_SET } from 'src/app/helpers';
import { Language } from 'src/app/services/languages.service';
import { environment } from 'src/environments/environment';
import { CoreStorageEnum } from 'src/app/models/core-storage.enum';

@Component({
    selector: 'app-navbar-noauth',
    templateUrl: './navbar-noauth.component.html',
    standalone: false
})
export class NavbarNoauthComponent implements OnInit {
  constructor(@Inject(LANG_SET) public langSet: Language[]) {}

  ngOnInit() {}

  public getClient() {
    var clientId = localStorage.getItem(CoreStorageEnum.clientId);
    if (!clientId) return '';
    if (clientId.endsWith('9')) return 'test environment';
    if (clientId.endsWith('8')) return 'uat environment';
    if (clientId.endsWith('1')) return '';
  }
}
